import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { zIndex } from 'styles';
import { DEEP_BORDER_BOX } from 'common';

const APP_BANNER_HEIGHT = '3rem';
const LOGO_WIDTH = '5.3125rem';

export default {
  AppBanner: styled.div`
    ${DEEP_BORDER_BOX}
    ${({ $rtl }) => $rtl && css` direction: rtl;`}
    background: ${({ $theme }) => $theme.background};
    color: ${({ $theme }) => $theme.primaryContent};
    height: ${APP_BANNER_HEIGHT};
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    padding-right: ${Tokens.SPACING.SPACING_16};
    padding-left: ${Tokens.SPACING.SPACING_24};
    z-index: ${zIndex.APP_BANNER};
    `,
  Logo: styled.div`
    display: flex;
    flex: auto 0 1;
    overflow: hidden;
    width: 100%;
    max-width: ${LOGO_WIDTH};
    ${({ $rtl }) => ($rtl ? `margin-left: ${Tokens.SPACING.SPACING_16}` : `margin-right: ${Tokens.SPACING.SPACING_16}`)};
    ${({ $rtl }) => ($rtl ? `margin-right: ${Tokens.SPACING.SPACING_16}` : `margin-left: ${Tokens.SPACING.SPACING_16}`)};
    img {
      max-width: ${LOGO_WIDTH};
      max-height: 2rem;
    }
    div {
      /** TODO: investigate why this offset is needed */
      height: 100%;
      width: 100%;
      display: flex;
    }
    svg {
      vertical-align: middle;
    }
    &:first-child {
      ${({ $rtl }) => ($rtl ? 'margin-right: 0' : 'margin-left: 0')};
    }
    // when drawer is expanded (in mobile view)
    ${({ $expanded }) => $expanded && css`display: none;`}
  `,
  AppBannerName: styled.h1`
    ${css`${Tokens.TYPOGRAPHY.TITLE_16}`};
    font-weight: normal;
    color: ${({ $theme }) => $theme.primaryContent};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: auto;
    margin-bottom: auto;
  `,
  AppBannerNameSecondary: styled.h3`
    margin-left: ${({ $rtl }) => ($rtl ? '0' : Tokens.SPACING.SPACING_12)};
    margin-right: ${({ $rtl }) => ($rtl ? Tokens.SPACING.SPACING_12 : '0')};
    margin-top: auto;
    margin-bottom: auto;
    ${css`${Tokens.TYPOGRAPHY.TITLE_16}`};
    font-family: ${Tokens.FONT_FAMILY.NOKIA_PURE_TEXT};
    font-weight: normal;
    color: ${({ $theme }) => $theme.secondaryContent};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ $expanded }) => $expanded && css`display: none;`}
  `,
  AppBannerDivider: styled.div`
    width: 0.0625rem;
    margin: 0 ${Tokens.SPACING.SPACING_16};
    background: ${({ $theme }) => $theme.divider};
    ${({ $expanded }) => $expanded && css`display: none;`}
  `,
  AppBannerContent: styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-end
  `,
  AppBannerDrawer: styled.div`
    display: flex;
    ${({ mobileView }) => mobileView && css`
      display: none;
    `};
    ${({ $expanded }) => $expanded && css`
      display: flex;
      // equal spacing between drawer children
      & > div, & > div:not(:last-child):not([class^="styles__TenantSwitchAvatar-"]) {
        ${({ $rtl }) => ($rtl ? `margin-left: ${Tokens.SPACING.SPACING_8}` : `margin-right: ${Tokens.SPACING.SPACING_8}`)};
      }
    `};
  `
};
